export default __webpack_public_path__ + "static/media/logo-sousTitreur.345da3e3.svg";